<template>
    <div class="context">
        <div class="header">
            <div class="btn_box">
                <div class="btn nomal_btn" @click="goBack">
                    <i class="el-icon-back"></i>
                    返回
                </div>
            </div>
            <div class="title">{{viewTitle}}</div>
        </div>

        <div class="main_box">
            <el-form :model="form" ref="ruleForm" label-width="100px" :rules="rules">
                <el-form-item label="名称:" prop="name">
                    <el-input v-model="form.name"
                              class="width_600"
                              placeholder="名称"></el-input>
                </el-form-item>
                <el-form-item label="默认周期:">
                    <el-radio-group v-model="form.ifDefault">
                        <el-radio v-for="(item, index) in ifDefaultList"
                                  :key="index"
                                  :label="item.value">{{item.name}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="阶段:" v-if="form.ifDefault == 2">
                    <div class="stage_item" v-for="(item, index) in commonForm.stage_list" :key="index">
                        <div class="stage_title">
                            <div class="title">T{{index + 1}}, 共{{item.days}}天</div>
                        </div>
                        <div class="cycle_item" v-for="(items, indexs) in item.cycle_list" :key="indexs">
                            <div class="title" v-text="showCycle(index, indexs)">
                            </div>
                            <div class="input_box">
                                <el-input class="width_200"
                                          placeholder="名称"
                                          :disabled="true"
                                          v-model="items.name"></el-input>
                                <span>：</span>
                                <el-input-number v-model="items.days"
                                                 controls-position="right"
                                                 :disabled="true"
                                                 :min="0"></el-input-number>
                                <span>天</span>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="阶段:" v-if="form.ifDefault == 1">
                    <div class="stage_item" v-for="(item, index) in form.stage_list" :key="index">
                        <div class="stage_title">
                            <div class="title">T{{index + 1}}, 共{{item.days}}天</div>
                            <div class="btn_box">
                                <div class="btn del_icon"
                                     v-if="form.stage_list.length > 1"
                                     @click="delStage(index)">删除</div>
                                <div class="btn"
                                     v-if="index === form.stage_list.length - 1"
                                     @click="addStage()">添加</div>
                            </div>
                        </div>
                        <div class="cycle_item" v-for="(items, indexs) in item.cycle_list" :key="indexs">
                            <div class="title" v-text="showCycle(index, indexs)">
                            </div>
                            <div class="input_box">
                                <el-input class="width_200"
                                          placeholder="名称"
                                          v-model="items.name"></el-input>
                                <span>：</span>
                                <el-input-number v-model="items.days"
                                                 controls-position="right"
                                                 @change="changeNum(index)"
                                                 :min="0"></el-input-number>
                                <span>天</span>
                            </div>
                            <div class="btn_box">
                                <div class="icon del_icon"
                                     @click="delCycle(indexs, index)"
                                     v-if="item.cycle_list.length > 1">
                                    <i class="el-icon-remove-outline"></i>
                                </div>
                                <div class="icon"
                                     v-if="indexs === item.cycle_list.length - 1"
                                     @click="addCycle(index)">
                                    <i class="el-icon-circle-plus-outline"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="是否审批:" prop="approved">
                    <el-radio-group v-model="form.approved">
                        <el-radio v-for="(item, index) in approvedOption"
                                  :label="item.value"
                                  :key="index">
                            {{item.name}}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submit">提交</el-button>
                    <el-button @click="goBack">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {clone} from "@/global/utils";

    export default {
        name: "add",
        data() {
            return {
                viewTitle: '新建病种',
                form: {
                    name: '',
                    approved: 1,
                    ifDefault: 1,
                    stage_list: [
                        {
                            name: 'T1',
                            days: 0,
                            cycle_list: [{name: '', days: 0}]
                        }

                    ],
                },
                commonForm: {
                    stage_list: [
                        {
                            name: 'T1',
                            days: 0,
                            cycle_list: [{name: '', days: 0}]
                        }

                    ],
                },
                rules: {
                    name: [{required: true, message: '请输入名称！', trigger: 'blur'}]
                },
                approvedOption: [
                    {name: '是', value: 1},
                    {name: '否', value: 2}
                ],
                ifDefaultList: [
                    {name: '使用', value: 2},
                    {name: '不使用', value: 1},
                ]
            }
        },
        computed: {
            ...mapState('manageData', [
                'ill_data'
            ])
        },
        mounted() {
            if (this.ill_data) {
                this.viewTitle = '修改病种';
                this.form = clone(this.ill_data);
                this.form.ifDefault = this.form.cycle_tumour_id == 0 ? 2 : 1;
            } else {
                this.viewTitle = '新建病种';
                this.form = {
                    name: '',
                    approved: 1,
                    ifDefault: 1,
                    stage_list: [
                        {
                            name: 'T1',
                            days: 0,
                            cycle_list: [{name: '', days: 0}]
                        }

                    ],
                }
            }
            this.getCommonData()
        },
        methods: {
            goBack() {
                this.$emit('changeTopTab', 'tableView')
            },
            getCommonData() {
                this.httpGet('/tumour/default').then(res => {
                    if (res.data) {
                        this.commonForm = res.data
                    } else {
                        this.commonForm = {
                            stage_list: [
                                {
                                    name: 'T1',
                                    days: 0,
                                    cycle_list: [{name: '', days: 0}]
                                }
                            ],
                        }
                    }
                })
            },

            changeNum(index) {
                let num = 0;
                this.form.stage_list[index].cycle_list.forEach(v => {
                    if (v.days) {
                        num += v.days
                    }
                });
                this.form.stage_list[index].days = num
            },
            showCycle(index, indexs) {
                let list = this.form.stage_list;
                let num = 0;
                for (let i = 0; i<index; i++) {
                    if (list[i] && list[i].cycle_list) {
                        num = num + list[i].cycle_list.length
                    }
                }
                num = num + indexs + 1;
                return `Cycle${num}:`
            },

            addStage() {
                let item = {
                    name: '',
                    days: 0,
                    cycle_list: [{name: '', days: 0}]
                };
                this.form.stage_list.push(item)
            },
            delStage(index) {
                this.form.stage_list.splice(index, 1)
            },
            addCycle(index) {
                let item = {
                    name: '',
                    days: ''
                };
                this.form.stage_list[index].cycle_list.push(item)
            },
            delCycle(indexs, index) {
                this.form.stage_list[index].cycle_list.splice(indexs, 1);
                this.changeNum(index)
            },
            submit() {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        this.form.default = this.form.ifDefault;
                        this.form.stage_list.forEach((v, i) => {
                            v.name = `T${i + 1}`
                        });
                        if (this.viewTitle === '新建病种') {
                            this.httpPost('/tumour', this.form).then(res => {
                                this.$message.success('添加成功！');
                                this.goBack()
                            })
                        } else if (this.viewTitle === '修改病种') {
                            this.httpPost(`/tumour`, this.form).then(res => {
                                this.$message.success('修改成功！');
                                this.goBack()
                            })
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    $view_background: rgb(246, 247, 248);
    $btn_border: rgb(246, 247, 248);
    .context {
        width: 100%;
        height: 100%;
        background: $view_background;

        .del_icon {
            color: #F56C6C;
        }

        .header {
            width: 100%;
            line-height: 50px;
            padding: 0 15px;
            box-sizing: border-box;
            display: flex;
            border-bottom: 1px solid #ddd;
            /*color: #8d8d8d;*/
            .title {

            }
            .btn_box {
                padding-right: 20px;
                .btn {
                    margin-top: 10px;
                    border: 1px solid $btn_border;
                }
            }
        }
        .main_box {
            padding: 10px;
            height: calc(100% - 55px);
            overflow: hidden;
            overflow-y: auto;
            .stage_item {
                width: 600px;
                border-radius: 3px;
                padding: 5px;
                background: #fff;
                .stage_title {
                    background: #f5f7fa;
                    line-height: 40px;
                    width: 100%;
                    padding: 0 20px;
                    display: flex;
                    justify-content: space-between;
                    box-sizing: border-box;
                    .btn_box {
                        display: flex;
                        .btn {
                            padding: 0 10px;
                        }
                    }
                }
                .cycle_item {
                    padding-left: 40px;
                    line-height: 40px;
                    display: flex;
                    padding-bottom: 5px;
                    margin: 5px 0;
                    &:last-child {
                        padding-bottom: 0;
                    }
                    .title {
                        flex: 0 0 50px;
                        width: 50px;
                        text-align: center;
                    }
                    .input_box {
                        flex: 1;
                        span {
                            padding: 0 5px;
                        }
                    }
                    .btn_box {
                        flex: 0 0 80px;
                        display: flex;
                        .icon {
                            flex: 1;
                            width: 40px;
                            line-height: 40px;
                            font-size: 1.5rem;
                            cursor: pointer;
                        }

                    }
                }
            }

            .sql_box {
                width: 600px;
                background: #fff;
                border-radius: 3px;
                padding: 5px;
                .sql_item {
                    line-height: 40px;
                    display: flex;
                    padding-bottom: 5px;
                    &:last-child {
                        padding-bottom: 0;
                    }
                    .title {
                        flex: 0 0 50px;
                        width: 50px;
                        text-align: center;
                    }
                    .input_box {
                        flex: 1;
                        span {
                            padding: 0 5px;
                        }
                    }
                    .btn_box {
                        flex: 0 0 80px;
                        display: flex;
                        .icon {
                            flex: 1;
                            width: 40px;
                            line-height: 40px;
                            font-size: 1.5rem;
                            cursor: pointer;
                        }
                        .del_icon {
                            color: #F56C6C;
                        }
                    }
                }
            }
        }
    }
</style>